export const BASIC_COLOR = "#a63a50";
export const BASIC_COLOR_LIGHT = "#b86173";
